export default __webpack_public_path__ + "media/zurb/img/case-study-libdib/libdib-img4-98c9fe44bba644bb3e31135d79fa4e44.jpg";